export const getPluralProductName = (name, amount = 1) => {
  switch(name.toLowerCase()) {
    case 'Beach Day Pass':
      return `Beach Day Pass${amount > 1 ? 'es' : ''}`;
    case 'Pool and Beach Day Pass':
      return `Pool and Beach Day Pass${amount > 1 ? 'es' : ''}`;
    case 'day pass':
      return `Day Pass${amount > 1 ? 'es' : ''}`;
    case 'cabana':
      return `Cabana${amount > 1 ? 's' : ''}`;
    case 'spa pass':
      return `Spa Pass${amount > 1 ? 'es' : ''}`;
    case 'daybed':
      return `Daybed${amount > 1 ? 's' : ''}`;
    case 'addon':
      return `Addon${amount > 1 ? 's' : ''}`;
    case 'fitness pass':
      return `Fitness Pass${amount > 1 ? 'es' : ''}`;
    case 'events':
      return `Events`;
    default:
      return `Day Pass${amount > 1 ? 'es' : ''}`;
  }
};
